module.exports = __webpack_public_path__ + "img/2.af5a72b6.jpg";